// per-area summary (detection sub-areas like water / gas leak separately, other branches as one area each) for the project report
import { actual, qtyNum } from './pmQty';

export const areaKey = (r) => { const b = r.pm?.branch; if (!b) return null; return b === 'detect' ? `detect:${r.pm.sub || 'water'}` : b; };
const counts = (r) => r.pm && r.pm.status !== 'draft' && !r.pm.addendumOf;

export function areaSummary(p, reports = p.reports || []) {
  const G = new Map(), reps = reports.filter(counts);
  const g = (k) => { if (!G.has(k)) G.set(k, { key: k, branch: k.split(':')[0], sub: k.split(':')[1] || null, n: 0, from: null, to: null, teams: new Set(), plan: 0, ist: 0, cost: false, shared: false, qty: new Map() }); return G.get(k); };
  for (const r of reps) {
    const k = areaKey(r); if (!k) continue;
    const x = g(k), at = r.pm.at || r.updatedAt || r.createdAt;
    x.n += 1; if (at) { x.from = Math.min(x.from ?? at, at); x.to = Math.max(x.to ?? at, at); }
    if (r.pm.team) x.teams.add(r.pm.team);
  }
  const subs = p.pm?.subs || [];
  for (const pos of p.pm?.positions || []) {
    const own = reps.filter((r) => r.pm.posId === pos.id), keys = [...new Set(own.map(areaKey).filter(Boolean))];
    if (!keys.length) (pos.branches || []).forEach((b) => { if (b !== 'detect') keys.push(b); else if (subs.length === 1) keys.push(`detect:${subs[0]}`); });
    const keep = keys.filter((k) => G.has(k)), shared = keep.length > 1;
    for (const line of pos.lines || []) {
      const price = qtyNum(line.price), plan = qtyNum(line.plan), a = actual(p, pos, line), byRep = a.how === 'reports';
      keep.forEach((k) => {
        const x = G.get(k), ist = byRep ? own.filter((r) => areaKey(r) === k).reduce((s, r) => s + (qtyNum(r.pm?.qty?.[line.id]) || 0), 0) : a.v || 0;
        x.shared = x.shared || shared;
        const q = x.qty.get(`${line.name}|${line.unit}`) || { name: line.name || '–', unit: line.unit || '', plan: 0, ist: 0 };
        q.plan += plan || 0; q.ist += ist; x.qty.set(`${line.name}|${line.unit}`, q);
        if (price == null) return;
        x.cost = true; if (plan != null) x.plan += plan * price; x.ist += ist * price;
      });
    }
  }
  return [...G.values()].map((x) => ({ ...x, teams: [...x.teams], qty: [...x.qty.values()] })).sort((a, b) => b.n - a.n);
}
